import React from 'react';
import {COLORS} from '../../../../../constants/colors';
import {Icon} from '../../../../atoms/Icon/Icon';
import {GenericIconName} from '../../../../atoms/Icon/IconName';
import {BasicControl} from './BasicControl';

export const PlayControl: React.FC<{
  playFunction: () => void;
}> = ({playFunction}) => {
  return (
    <BasicControl onClick={playFunction}>
      <Icon
        asset={GenericIconName.Play}
        width={20}
        height={20}
        fillOpacity={0.6}
        strokeWidth={2}
        fill={COLORS.White}
      />
    </BasicControl>
  );
};
